module.exports = __webpack_public_path__ + "img/fe98587.jpg";